import moment from 'moment';
import { Action, IPayload, State } from './interfaces';

export const initialPaymentState: State = {
  totals: {
    totalRows: 0,
    totalAmountAdvanceDiscount: 0,
    totalAmount: 0,
    totalPaidValue: 0,
    totalAddReturnInvoice: 0,
    totalAmountToPay: 0,
    totalDownloadDiscountValue: 0,
    totalResaleDiscountValue: 0,
    totalGCDiscountValue: 0,
    totalNoShowPenalty: 0,
    totalLateChange: 0,
    totalAmountReturnInvoice: 0
  }
};

export const reducerPayments = (state: State, action: Action) => {
  const handleTotals = (payload: IPayload['payments'] | [], flagType: Action['flagType']) => {
    const totals = { ...initialPaymentState.totals };

    payload.map((item) => {
      const paymentDate = moment(item.paymentDate, 'DD/MM/YYYY');
      const isAfter = moment().isAfter(paymentDate);
      const isSameOrBefore = moment().isSameOrBefore(paymentDate);

      if (flagType.includes('Pagos') && isAfter) {
        if (item.paymentDetail.length > 0) {
          item.paymentDetail.map((detail) => {
            totals.totalLateChange += detail.schedulePenaltyAmount;
          });
        }
        totals.totalAddReturnInvoice += item.totalAddReturnInvoice;
        totals.totalAmountAdvanceDiscount += item.totalAmountAdvanceDiscount;
        totals.totalAmountReturnInvoice += item.totalAmountReturnInvoice;
        totals.totalDownloadDiscountValue += item.downloadDiscountValue;
        totals.totalResaleDiscountValue += item.resaleDiscountValue;
        totals.totalGCDiscountValue += item.totalGCDiscountValue;
        totals.totalNoShowPenalty += item.totalNoShowPenalty;
        totals.totalPaidValue += item.paidValue;
        totals.totalRows += 1;
        totals.totalAmount += item.totalAmount;
      }

      if (flagType.includes('Pendentes') && isSameOrBefore) {
        if (item.paymentDetail.length > 0) {
          item.paymentDetail.map((detail) => {
            totals.totalLateChange += detail.schedulePenaltyAmount;
          });
        }
        totals.totalAddReturnInvoice += item.totalAddReturnInvoice;
        totals.totalAmountAdvanceDiscount += item.totalAmountAdvanceDiscount;
        totals.totalAmountReturnInvoice += item.totalAmountReturnInvoice;
        totals.totalDownloadDiscountValue += item.downloadDiscountValue;
        totals.totalResaleDiscountValue += item.resaleDiscountValue;
        totals.totalGCDiscountValue += item.totalGCDiscountValue;
        totals.totalNoShowPenalty += item.totalNoShowPenalty;
        totals.totalAmountToPay += item.paidValue;
        totals.totalRows += 1;
        totals.totalAmount += item.totalAmount;
      }

      if (flagType.includes('Todos')) {
        if (item.paymentDetail.length > 0) {
          item.paymentDetail.map((detail) => {
            totals.totalLateChange += detail.schedulePenaltyAmount;
          });
        }
        totals.totalAddReturnInvoice += item.totalAddReturnInvoice;
        totals.totalAmountAdvanceDiscount += item.totalAmountAdvanceDiscount;
        totals.totalAmountReturnInvoice += item.totalAmountReturnInvoice;
        totals.totalDownloadDiscountValue += item.downloadDiscountValue;
        totals.totalResaleDiscountValue += item.resaleDiscountValue;
        totals.totalGCDiscountValue += item.totalGCDiscountValue;
        totals.totalNoShowPenalty += item.totalNoShowPenalty;
        totals.totalAmountToPay += isSameOrBefore ? item.paidValue : 0;
        totals.totalPaidValue += isAfter ? item.paidValue : 0;
        totals.totalRows += 1;
        totals.totalAmount += item.totalAmount;
      }
    });
    return totals;
  };

  switch (action.type) {
    case 'TOTALS':
      if (action.payload && action.payload.length > 0) {
        return {
          ...state,
          totals: handleTotals(action.payload, action.flagType)
        };
      }
      return initialPaymentState;
    default:
      return initialPaymentState;
  }
};
